import React from "react";
import cl from "./MadeByBimatter.module.css";
function MadeByBimatter() {
    return (
        <div
            className={cl.logo}
            onClick={() => {
                window.location.href = "https://www.bimatter.ru/";
            }}
        >
            <div
                className={cl.no_click}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            ></div>
        </div>
    );
}

export default MadeByBimatter;
